import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { EventState } from './eventsSlice';
import { EventCompleteRequest } from './../../model/event-complete-request';
import { EventCompleteResponse } from '../../model/event-complete-response';
import CameraDeleteRequest from '../../model/camera-delete-request';

export const onCompleteEvent = (state: Draft<EventState>) => {
  state.completeStatus = 'LOADING';
};

export const onCompleteEventSuccess = (
  state: Draft<EventState>,
  action: PayloadAction<{
    eventCompleteRequest: EventCompleteRequest;
    response: EventCompleteResponse;
  }>
) => {
  const { eventCompleteRequest, response } = action.payload;

  state.completeStatus = response.success ? 'SUCCESS' : 'FAILED';
  state.completeErrorMessage = undefined;
  if (response.success) {
    state.completionMessage =
      eventCompleteRequest.completionMode === 'USER_FORCE_COMPLETE' ||
      eventCompleteRequest.completionMode === 'WEB_UPLOADER_COMPLETE' ||
      eventCompleteRequest.completionMode === 'OVERRIDE_COMPLETE' ||
      response.isOverrideCompleted === 'Yes'
        ? 'This event is now complete.'
        : 'Event is scheduled to complete.';
  } else {
    state.completionMessage = undefined;
  }
  state.events = state.events.map((event) => {
    if (event.eventId === eventCompleteRequest.eventId) {
      const status = response.status ? response.status : event.status;
      const initiatedDate = response.initiatedDate;
      const initiatedUser = response.initiatedUser;
      const isOverrideCompleted = response.isOverrideCompleted;
      const validationErrors = response.success ? event.validationErrors : response.validationErrors;
      const completedBy = response.completedBy;
      const remainingTimeForEventCompletionTimerInSeconds = response.remainingTimeForEventCompletionTimerInSeconds;
      return {
        ...event,
        status,
        initiatedDate,
        initiatedUser,
        isOverrideCompleted,
        validationErrors,
        completedBy,
        remainingTimeForEventCompletionTimerInSeconds,
        overrideReasons: eventCompleteRequest.overrideRequest?.overrideReasons,
      };
    }
    return event;
  });
};

export const onCompleteEventFailed = (state: Draft<EventState>, action: PayloadAction<unknown>) => {
  state.completeStatus = 'FAILED';
  state.completeErrorMessage = action.payload as string;
};

export const onDeleteCamera = (state: Draft<EventState>) => {
  state.deleteCameraStatus = 'LOADING';
};

export const onDeleteCameraSuccess = (state: Draft<EventState>, action: PayloadAction<CameraDeleteRequest>) => {
  const deleteRequest = action.payload as CameraDeleteRequest;

  state.deleteCameraStatus = 'SUCCESS';
  state.deleteCameraErrorMessage = undefined;
  state.events = state.events.map((event) => {
    if (event.eventId !== state.selectedEventId) {
      return event;
    }

    return {
      ...event,
      days: event.days
        ?.map((day) => {
          const cameras = day.cameras?.filter(
            (camera) => camera.cameraId !== deleteRequest.cameraId || camera.mediaId !== deleteRequest.mediaIdentifier
          );

          if (cameras?.length === day.cameras?.length) {
            return day;
          }

          return { ...day, cameras };
        })
        ?.filter((day) => !!day.cameras?.length),
    };
  });
};

export const onDeleteCameraFailed = (state: Draft<EventState>, action: PayloadAction<unknown>) => {
  state.deleteCameraStatus = 'FAILED';
  state.deleteCameraErrorMessage = ('Error deleting camera: ' + action.payload) as string;
};
